import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const FileUpload = ({ files, isEditable = true  , setFiles, update, prop, formik, onFileSelect, maxWidth = 86, maxHeight = 78 }) => {
  const fieldName = prop.name || 'image'; 

  
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFiles(acceptedFiles[0]);
      if (onFileSelect) {
        const e = { target: { files: acceptedFiles } };
        onFileSelect(e);
      }
    }
  }, [setFiles, onFileSelect]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { 'image/*': [] },
    onDrop: isEditable ? onDrop : () => {}, 
    disabled: !isEditable,                 
  });
  
  

  const imageUrl = formik.values[fieldName] || files?.preview;
  console.log(imageUrl,"image preiview")

  return (
    <div className="col-md-6">
      <div className="">
        {prop.title}
        {/* Upload Rectangle Below */}
        <div
          {...getRootProps({ className: 'dropzone' })}
          className="custom-boxs cr-file-sec"
          style={{
            cursor: isEditable ? 'pointer' : 'not-allowed',
            backgroundColor: !isEditable ? '#f5f5f5' : '#fff',
            border: '2px dashed #ddd',
            padding: '20px',
            textAlign: 'center',
          }}
        >
          <input {...getInputProps()} />
          <div style={{
            color: '#666',
            fontSize: '14px'
          }}>
            <p style={{ margin: 0 }}>
              Drag & drop image here, or click to select image
            </p>
            {imageUrl && (
              <p style={{
                margin: '5px 0 0 0',
                fontSize: '12px',
                color: '#888'
              }}>
                Click or drag to replace the image
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-md-6">
        {/* Image Preview Above */}
        {imageUrl && (
          <div className="selected-file-preview"
            style={{
              marginBottom: '15px',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: '150px',
                height: '150px',
                objectFit: 'cover',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginLeft:"100px"
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUpload;